<template>
	<contentBox v-if="!loadError" v-bind:loading="loading">
		<contentTitle label="PARCEL COLLECTIONS" close="routeClose">
		</contentTitle>
		<contentBody v-bind:locked="token === null" bg="#f8f9fa">
			<ul class="collections-list list-group list-group-flush">
				<li v-on:click="routeUnlocked" class="list-group-item list-group-item-action justify-content-between d-flex align-items-center cursor-pointer">
					 Unlocked Parcels <span class="badge badge-dark badge-pill">{{unlockedLength}}</span>
					 <i class="material-icons md-18">lock</i>
				</li>
				<li v-if="collections" v-for="(row, index) in collections" :key="row.id" v-on:click="routeCollection(row.id)"
					class="list-group-item list-group-item-action justify-content-between d-flex align-items-center cursor-pointer">
					{{row.name}} <span class="badge badge-dark badge-pill">{{row.count || 0}}</span>
					<i class="material-icons md-18">bookmarks</i>
				</li>
				<li v-if="!addFormVisible" v-on:click="addFormShow" class="list-group-item list-group-item-action justify-content-between d-flex align-items-center cursor-pointer">
					Add Collection <i class="material-icons md-18">add</i>
				</li>
			</ul>
			<form v-if="addFormVisible" class="category form-group p-3 bg-white" v-on:submit.prevent="addFormSubmit">
		
				<div class="category-title">NEW COLLECTION NAME</div>
				<div class="property-row">
					<input type="text" class="form-control"
						placeholder="Enter a name" v-model="addFormRec.name"
						v-bind:class="{'is-invalid':error}"/>
					<div class="invalid-feedback">
						{{error}}
				   </div>
				</div>
				<div class="property-row">
					<button v-on:click.prevent="addFormHide" type="button" class="btn btn-light">Cancel</button>
					<button class="btn btn-dark float-right" type="submit">Add</button>
				</div>
			</form>

		</contentBody>
	</contentBox>
</template>

<script>

import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';

export default {
	name: 'collectionList',

	components:{
		contentBox,
		contentActions,
		contentBody,
		contentTitle,
	},

	computed: {
		collections: function(){
			return this.$store.state.collections.recs;
		},
		unlocked: function(){
			return this.$store.state.collections.unlocked;
		},
		unlockedLength: function(){
			return (this.$store.state.collections.unlocked && this.$store.state.collections.unlocked.length) || 0;
		},
		token: function(){
			return this.$store.state.agent.token;
		},
	},
	created: function(){
		this.get();
	},

	props: {

	},
	data: function(){
		return {
			addFormRec:{
				name:''
			},
			addFormVisible: false,
			error:null,
			loading: true,
			loadError: null,
		}
	},


	methods: {
		addFormHide:function(){
			this.addFormVisible = false
		},
		addFormShow:function(){
			this.addFormVisible = true
		},
		addFormSubmit:async function(e){
			this.loadError = null;
			this.loading = true;
			try {
				await this.$store.dispatch('COLLECTION_ADD',{name:this.addFormRec.name});
				this.addFormRec.name = '';
				this.loading = false;
			} catch(e){
				this.loadError = e;		
			}
		},
		get:async function(){
			this.loadError = null;
			try {
				await this.$store.dispatch('COLLECTIONS_GET');
				await this.$store.dispatch('COLLECTIONS_UNLOCKED_GET');
				this.loading = false;
			} catch(e){
				this.loadError = e;		
			}
		},
		routeClose:function(){
			this.$router.push({
				name: 'home', 
				params:{}
			});
		},
		routeCollection:function(collectionId){
			this.$router.push({
				name: 'collection', 
				params:{collectionId}
			});
		},
		routeUnlocked:function(){
			this.$router.push({
				name: 'collection-unlocked', 
				params:{}
			});
		},		
	},
	watch:{

	}
}

</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/collection/collection-list.vue